import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "20", height: "16", x: "2", y: "4", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Mail";
const Mail = memo(themed(Icon));
export {
  Mail
};
//# sourceMappingURL=mail.js.map
